import { render } from "./ZonePage.vue?vue&type=template&id=2bef8ee7&scoped=true&ts=true"
import script from "./ZonePage.ts?vue&type=script&lang=ts"
export * from "./ZonePage.ts?vue&type=script&lang=ts"

import "./ZonePage.vue?vue&type=style&index=0&id=2bef8ee7&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bef8ee7"]])

export default __exports__